/** 用户登录信息 */
import { SMSLoginFormField } from '@/components/LoginModal/SMSLoginForm';
import { RequestSuccess } from '@/services/knows/conversation';
import {
  bindPhone,
  checkProtocolByUser,
  checkUserCredits,
  fetchUserActivityList,
  findUser,
  loginServer,
  logout,
  updateAvatar,
  updateUser,
} from '@/services/user';
import {
  BindPhoneParams,
  CommonLoginParamsBySMS,
  FindUserResponse,
  KnowsUserInfo,
  ProtocolItem,
  SMSLoginResponse,
  UpdateUserParams,
  UserActivity,
} from '@/services/user/typings';
import { tryCatch } from '@/utils';
import {
  showKanghongActivity,
  showSevenDaysTrialActivity,
  showThreeDaysTrialActivity,
} from '@/utils/activityModal';
import { jumpLandingPage } from '@/utils/jump';
import { ResponseWrap, unwrapResponse } from '@/utils/request';
import { SLS_CLIENT } from '@aliyun-sls/web-browser';
import { message } from 'antd';
import { combine } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';
import { useNewProjectsStore } from '../newProjects';
import getRouterPermission from './routerPermission';

export type User = Pick<
  SMSLoginResponse,
  'id' | 'nickname' | 'phone' | 'state'
> & {
  avatar?: string | null;
  // weChat?: string | null;
  email?: string | null;
  credits?: number | null;
  protocols?: ProtocolItem[];
  locale?: string | null;
  showUserInfoForm?: boolean;
  tenant_id: string;
  routers: any[];
  activityList: UserActivity[];
  interfaceConfig?: KnowsUserInfo['tenant']['tenant_config']['web'];
} & Pick<
    FindUserResponse,
    'approval_status' | 'permission' | 'level' | 'valid_date'
  >;

const userCreator = combine(
  {
    value: null as User | null,
  },
  function (set, get) {
    function isLoggedIn() {
      return !!get().value;
    }

    function hasPhoneNumber() {
      return isLoggedIn() && !!get().value?.phone;
    }
    return {
      isLoggedIn,
      hasPhoneNumber,
      save(value: Partial<User>) {
        set({
          value: Object.assign({}, get().value, value),
        });
      },
      clearUser() {
        localStorage.removeItem('token');
        /** 清空新开的menu */
        useNewProjectsStore.setState({
          value: [],
        });
        set({
          value: null,
        });
      },
      async checkCreditLeft() {
        const { save } = this || get();
        tryCatch(async () => {
          const left = await checkUserCredits();
          if (typeof left === 'number') {
            save({ credits: left });
          }
        });
      },
      async checkProtocolByUser() {
        const { save } = this || get();
        tryCatch(async () => {
          const res = await checkProtocolByUser({});
          if (res?.data?.private_policy) {
            save({
              protocols: res?.data?.private_policy?.filter((p) => p?.state),
            });
          }
        });
      },
      async getActivities() {
        const { save } = this || get();
        try {
          const res = await fetchUserActivityList();
          if (res.code === RequestSuccess) {
            save({ activityList: res.data });
            if (res.data && res.data.length > 0) {
              showSevenDaysTrialActivity(res.data);
              showKanghongActivity(res.data);
              showThreeDaysTrialActivity(res.data);
              // const sevenDay = res.data.find(
              //   (item) => item.activity_id === 'seven-days-trial-activity',
              // );
              // if (sevenDay) {
              //   Modal.info({
              //     title: '',
              //     content: '',
              //     okText: '立即领取',
              //     maskClosable: false,
              //     closable: true,
              //     centered: true,
              //     width: 'fit-content',
              //     height: 'fit-content',
              //     icon: null,
              //     cancelButtonProps: {
              //       style: {
              //         display: 'none',
              //       },
              //     },
              //     okButtonProps: {
              //       style: {
              //         width: '100%',
              //         height: 48,
              //         borderRadius: 16,
              //         color: '#fff',
              //         fontSize: 16,
              //         fontFamily: 'MiSans',
              //         fontWeight: 630,
              //       },
              //     },
              //     styles: {
              //       content: {
              //         padding: 12,
              //         width: 314,
              //         height: 293,
              //         paddingTop: 212,
              //         backgroundColor: '#fff',
              //         borderRadius: 20,
              //         background: `linear-gradient(180deg, #FCEEFF 0%, #E3F3FF 54.43%), #F1F6F9`,
              //         backgroundImage: `url('https://nullht-official-website.oss-cn-shanghai.aliyuncs.com/KNOWS_DOCTOR/ACTIVITY_IMAGES/aiagent/20250808-14500.png')`,
              //         backgroundSize: '100% 100%',
              //         backgroundPosition: 'center',
              //         backgroundRepeat: 'no-repeat',
              //       },
              //     },

              //     onOk: async () => {
              //       try {
              //         await unwrapResponse(
              //           userActivityConsume('seven-days-trial-activity'),
              //           {
              //             success: (res) => {
              //               if (res.code === RequestSuccess) {
              //                 window.location.reload();
              //               }
              //             },
              //             fail: (res) => {
              //               message.error(res?.msg || '领取失败');
              //               // window.location.reload();
              //             },
              //           },
              //         );
              //       } catch (e) {}
              //     },
              //   });
              // }
            }
          }
        } catch (e) {
          console.error(e);
        }
      },

      async findUser(options?: {
        success?: (user: FindUserResponse) => void;
        fail?: (result?: ResponseWrap<FindUserResponse>) => void;
      }) {
        const { save, checkProtocolByUser, getActivities } = this || get();
        try {
          const res = await findUser();
          if (res.data) {
            const userInfo = res.data;
            save({
              id: userInfo.user_id!,
              nickname:
                userInfo.nick_name ||
                userInfo.mobile ||
                userInfo?.email ||
                'user',
              email: userInfo.email,
              phone: userInfo.mobile,
              avatar: userInfo.avatar,
              state: userInfo?.state,
              showUserInfoForm: !userInfo.is_complete,
              // weChat: userInfo?.wechat_name,
              level: userInfo?.level,
              permission: userInfo?.permission,
              valid_date: userInfo?.valid_date,
              tenant_id: userInfo?.tenant?.tenant_id,
              interfaceConfig: userInfo?.tenant?.tenant_config?.web,
              routers: getRouterPermission(userInfo?.permission?.permission),
            });

            if (userInfo.user_id) {
              checkProtocolByUser();
              getActivities();
              SLS_CLIENT.setOptions({
                uid: userInfo.user_id, // 更新用户ID
              });
            }

            options?.success?.(res.data);
            return;
          }
          options?.fail?.(res);
        } catch (e) {
          options?.fail?.();
        }
      },
      async phoneLogin(form: SMSLoginFormField) {
        const { findUser } = this || get();

        // LOGIN 手机号登录
        await unwrapResponse(
          loginServer({
            phone: form.phone,
            account_captcha: form.code,
          } as CommonLoginParamsBySMS),
          {
            fail: (res) => {
              message.error(res.msg);
            },
            success: () => {
              findUser();
            },
          },
        );
      },
      updateUser(data: UpdateUserParams) {
        tryCatch(async () => {
          const { save } = this || get();
          await unwrapResponse(updateUser(data));
          save({
            id: data.id,
            nickname: data.name,
          });
        });
      },
      async bindPhone(data: BindPhoneParams) {
        const { save } = this || get();
        const res = await bindPhone(data);
        if (res.code === '00000') {
          save({
            phone: data.phone,
          });
        }
        return res;
      },
      async updateAvatar(data: { file_key: string }, errorInfo: string) {
        const { findUser } = this || get();
        try {
          await unwrapResponse(updateAvatar(data), (res) => {
            message.error(res.msg);
          });
          findUser();
        } catch (e) {
          message.error(errorInfo);
        }
      },
      logout() {
        const { clearUser } = this || get();
        tryCatch(async () => {
          await unwrapResponse(logout());
          clearUser();
          jumpLandingPage();
        });
      },
    };
  },
);

export const useUserStore = createWithEqualityFn(userCreator);
